import { useModal } from "@/hooks/useModal";
import Navbar from "./Navbar";
import Footer from "./Footer";
import QuoteModal from "./QuoteModal";
import DemoModal from "./DemoModal";

export default function PageShell({ children }: { children: React.ReactNode }) {
  const { modalType, openQuote, openDemo, closeModal } = useModal();

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-dark-bg text-gray-900 dark:text-gray-100 transition-colors duration-300">
      <Navbar onQuoteClick={openQuote} />
      <main className="flex-1">{children}</main>
      <Footer />
      <QuoteModal open={modalType === "quote"} onClose={closeModal} />
      <DemoModal open={modalType === "demo"} onClose={closeModal} />
    </div>
  );
}
